import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal, { type ModalDialogProps } from '@atlaskit/modal-dialog';
import type { MaybeChoreographedComponentProps } from '@atlassian/jira-choreographer-services/src/types.tsx';
import { shouldBeChoreographed } from '@atlassian/jira-choreographer-services/src/utils.tsx';
import { isMobileAndInViewPanelIterationExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';
import { ChoreographerModal } from './choreographer-modal.tsx';

export type JiraModalProps = ModalDialogProps & MaybeChoreographedComponentProps;

export const JiraModal = (props: JiraModalProps) => {
	if (shouldBeChoreographed(props)) {
		if (isMobileAndInViewPanelIterationExperiment()) {
			return null;
		}
		const { messageType, ...rest } = props;
		return <ChoreographerModal {...rest} />;
	}

	const { messageType, messageId, onMessageDisposition, ...rest } = props;
	return <Modal {...rest} />;
};

JiraModal.displayName = 'JiraModal';
